module.exports = __webpack_public_path__ + "img/405.5a925af0.png";